import script from "./editPop.vue?vue&type=script&setup=true&lang=js"
export * from "./editPop.vue?vue&type=script&setup=true&lang=js"

import "./editPop.vue?vue&type=style&index=0&id=557d54b6&lang=less&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-557d54b6"]])

export default __exports__